import React from "react";
import ReactQuill, { Quill } from "react-quill";
let Embed = Quill.import("blots/block/embed");
const imageTypes = [".jpg", ".gif", ".jpeg", ".webp", ".png"];
class QuillAttachment extends Embed {
  static create(attachment) {
    let node = super.create();
    const span = document.createElement("div");
    span.setAttribute("data-attr", attachment);

    try {
      const parsed = JSON.parse(attachment);
      if (parsed && imageTypes.indexOf(parsed.ext.toLowerCase()) > -1) {
        const img = document.createElement("img");
        img.setAttribute("src", parsed.link);
        img.className += " at-image";
        span.append("", img);
      } else {
        const anchor = document.createElement("a");
        anchor.setAttribute("href", parsed.link);
        anchor.setAttribute("target", "_blank");
        anchor.textContent = `${parsed.name}`;
        span.appendChild(anchor);
        span.className += " at-file";
      }
    } catch (error) {}
    node.appendChild(span);

    return node;
  }
  static value(domNode) {
    // console.log({ domNode });
    return domNode.firstChild.getAttribute("data-attr");
  }
}
QuillAttachment.blotName = "attachment";
QuillAttachment.tagName = "div";
QuillAttachment.className = "attachment";

Quill.register(QuillAttachment, true);
